import { connect } from 'react-redux';
import { actions as modalReducers } from '~/modals/reducer';

import ThirdParty from './components/Loader';

export default connect((state) => {
  const { modals } = state;

  const modalsShowing = modalReducers.isShowingModals({ modals });

  return {
    zendeskWidget: state.thirdparty.zendeskWidget,
    modalsShowing,
    userId: state.user?.id,
  };
})(ThirdParty);

// export reducer, actions and action types
export { default as reducer, actions, actionTypes } from './reducer';
export { default as middleware } from './middleware';
